<div class="stt-container" *ngIf="isSTTEnabled()">
  <button cdkOverlayOrigin #origin="cdkOverlayOrigin"
    class="toolbar-icon"
    [class.is-pj]="isPj"
    [class.is-g6]="isG6"
    [class.is-active]="isRecordingSpeech"
    (click)="onMicClick()"
    (mousedown)="keepInputFocus($event)"
    [attr.aria-label]="'Speech-to-Text'">
    <i class="fas fa-microphone toolbar-icon-icon" aria-hidden="true"></i>
    <span class="stt-recording-dot" *ngIf="isRecordingSpeech"></span>
  </button>
  <ng-template cdkConnectedOverlay #tooltipOverlay="cdkConnectedOverlay" [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="showTip" [cdkConnectedOverlayPositions]="positions" (backdropClick)="closeTip()"
    [cdkConnectedOverlayHasBackdrop]="false">
    <div class="stt-tooltip">
      <div class="arrow"></div>
      <h4>{{ tipTitle }}</h4>
      <p>{{ tipBody }}</p>
    </div>
  </ng-template>
</div>


